<app-material>
    <div class="header" header>
        <h2>{{ 'atom.tool-returns.table.title-lines' | translate }}</h2>
    </div>
    <ng-container body>
        <app-tool-returns-table [toolReturns]="toolReturns"
                                [statusFilters]="filterStatusList"
                                [tableConfig]="tableConfig"
                                [isLoading]="isLoading"
                                [hasTitle]="false"
                                [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                (sortChange)="onSortChange($event)"
                                (filterChange)="onFilter($event)"
                                (actionClick)="onActionClick($event)"
                                (pageChange)="onPageChange($event)">
        </app-tool-returns-table>
    </ng-container>
</app-material>
